export interface PersonDetails {
    personId: string;
    treeId: string;
}

export const enum Relationship {
    Father = "f",
    Mother = "m",
    Sibling = "b",
    Spouse = "s",
    Child = "c",
}

interface FamilyMember {
    GivenName: string;
    Surname: string;
    Relationship: Relationship;
}

export const enum LifeEventType {
    Birth = "b",
    Death = "d",
    Marriage = "m",
    Residence = "r",
    Any = "y",
}

interface LifeEventDate {
    Year: number | null;
    Month: number | null;
    Day: number | null;
}

interface LocationGpids {
    Gpid: number;
    GpidHierarchy: number[];
    GpidHierarchyIndex: number;
}

export interface LifeEvent {
    Type: LifeEventType;
    Date: LifeEventDate;
    LocationText: string;
    LocationGpids: LocationGpids | null;
}

export type Person = {
    GivenName: string;
    Surname: string;
    LifeEvents: LifeEvent[];
    TreeId: string;
    PersonId: string;
    FamilyMembers: FamilyMember[];
    MotherSurname?: string;
    FatherSurname?: string;
    Gender?: string;
};

export type PersonSuggestionItem = {
    TreeId: string;
    PersonId: string;
    FullName: string;
    FormattedFullName: string;
    GivenName: string;
    Surname: string;
    BirthYear?: number;
    DeathYear?: number;
};

export type PersonSuggestions = Array<PersonSuggestionItem>;
